export default __webpack_public_path__ + "static/media/ok.cb349385.svg";